import dayjs from "dayjs";

export const DISCOUNT_TYPES = [
  { value: "flat", label: "$ off monthly rent" },
  { value: "percent", label: "% off monthly rent" },
  { value: "fixed", label: "Set a special rent" },
  /*{ value: "free_months", label: "Free month(s)" },*/
];

const toNumber = (val) => parseFloat(val?.toString()?.replace(/,/g, "")) || 0;

export const formatMoney = (val) => "$" + toNumber(val).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

// Monthly offer price for a unit. For "free_months" the monthly rent is unchanged.
export const getOfferPrice = (rent, discountType, discountAmount) => {
  const r = toNumber(rent);
  const d = toNumber(discountAmount);

  if (discountType === "percent") return Math.max(r - (r * Math.min(d, 100)) / 100, 0);
  if (discountType === "fixed") return d;
  if (discountType === "free_months") return r;
  return Math.max(r - d, 0);
};

export const getOfferSummary = (unit) => {
  const type = unit?.discount_type;
  const amount = toNumber(unit?.discount_amount);

  if (type === "free_months") return amount + " month" + (amount === 1 ? "" : "s") + " free";
  if (type === "percent") return amount + "% off/mo";
  if (type === "fixed") return "Special rent";
  return formatMoney(amount) + " off/mo";
};

// An offer is live when the unit is Available, the offer is switched on and it has not passed its Offer End date.
export const isOfferActive = (unit) => {
  if (!unit || parseInt(unit?.current_status) !== 1 || parseInt(unit?.special_pricing_enabled) !== 1) return false;

  if (unit?.offer_move_in_to) {
    return !dayjs().isAfter(dayjs(unit.offer_move_in_to), "day");
  }

  return true;
};
